import { AmazonService } from "../../../../services/amazon.service";
import { Seller } from "../../../../objects/amazon/seller";
import { Injectable } from "@angular/core";
import { SearchResponse } from "../../../../objects/responses/searchResponse";
import { ActivatedRouteSnapshot, Router } from "@angular/router";


@Injectable()
export class AmazonProductResolver {
    constructor(private amazonService: AmazonService, private router: Router) {
    }

    public resolve(route: ActivatedRouteSnapshot, router: Router): Promise<SearchResponse<Seller>> {
        let sellerId = route.params["sellerId"];
        let storeId = route.params["storeId"];
        let top: number = 50;
        let isAdmin: boolean = true;

        if(router.url.indexOf('/amazon/info') > -1){
            top = 10;
            isAdmin = false;
        }

        return this.amazonService.getProducts(sellerId, storeId, 0, top, isAdmin).then(result => {
            return result.Data;
        }).catch(err => {
            return null;
        });
    }
}


// WEBPACK FOOTER //
// ./app/components/Managment/amazon-management/store/amazon-product.resolver.ts